module.exports = __webpack_public_path__ + "img/TS6301-308.d0bbff0b.jpg";